<template>
  <div>
      <vs-progress :percent="viewpercentage" color="success">success</vs-progress><br>
       <h6>Work Progress {{viewpercentage}}% Completed!</h6><br>
       <h6>{{viewwork.detail}} # {{viewwork.id}}</h6><br>
      <vs-row>
        <vs-col vs-lg="6" vs-xs="12" vs-sm="12">
          <h6 v-if="viewwork" style="font-size: 100%">
          Started by: {{viewwork.username}}<br>
          Asset: -<br>
          Work detail: {{viewwork.detail}}<br>
          Created date: {{viewwork.timestamp}}<br>
          Last edited: {{viewwork.editdate}}<br>
          Time Spent: {{viewwork.timespent}}
          </h6>
        </vs-col>
        <vs-col vs-lg="6" vs-xs="12" vs-sm="12">
          <h6 v-if="viewwork" style="font-size: 100%">
          Start Date: {{viewwork.plandate}}<br>
          Actual start date: {{viewwork.startdate}}<br>
          End Date: {{viewwork.duedate}}<br>
          Actual End Date: {{viewwork.finishtime}}<br>
          Status: {{viewwork.iscomplete}}<br>
          WO Status : 
          </h6>
        </vs-col>
       
      </vs-row><br>
       <h6 class=" mb-2" >Completion Notes :</h6>
       <vs-textarea v-model="textarea" />
       <vs-button  icon="done" size="small" @click="complete" class="rounded-pill" color="success" type="filled">Complete</vs-button>
      <!-- <FormRenderer :form-configuration="formData" v-model="formInputData"/> -->
  
  </div>
</template>

<script>
import {FormRenderer} from 'v-form-builder';
export default {
  name: 'WO',
  components: {
    FormRenderer,
  },
  props: [
    'viewwork',
  ],
  computed: {
  },
  data: () => ({
    role: '',
    viewpercentage: 0,
    formData: '',
    activePrompt: false,
  }),
  methods: {
    view() {
    },
    complete(){
      console.log(this.viewwork.id, this.viewwork.username)
      const body = {
        id: this.viewwork.id,
        username : this.viewwork.username,
         status: 'true'
      }
      this.$http.post(this.$url2+'updateworkstatus',body).then((result)=>{
        if(result.status == 200) this.$vs.notify({title:'Work Order Updated',text:'Your work order has been updated',color: 'primary',position:'top-center'})
        setTimeout(()=> { 
          location.reload(1); 
        }, 1000);
      }).catch((err)=>{
        if(err.response.status == 500) this.$vs.notify({title:'Invalid',text:'Please try again',color: 'warning',position:'top-center'})
      })
      console.log(body)
    }
  },
  mounted() {
    this.role = this.$session.get('role')
    console.log('mounting table')
    this.viewpercentage = 0
    var maxitem = 0
    var nullitem = 0
    var item = this.viewwork
    console.log(item)
    this.formData = item.form
    this.activePrompt = true
    setTimeout(() => {
      this.formInputData = item.inputdata
      console.log(this.formInputData)
      if(item.inputdata) {
        Object.keys(item.inputdata).forEach(element => {
          maxitem += 1
          if(item.inputdata[element] == null || item.inputdata[element] == 0 || item.inputdata[element] == '') {
            nullitem += 1
          }
        });
        this.viewpercentage = ([(maxitem-nullitem)/maxitem]*100).toFixed(2)
      }
    }, 200);
  }
}
</script>